(() => {
  'use strict';
  if (customElements.get('sh-classic-mask-offers')) return;
  function makeItems(main, second) {
    if (!Number.isSafeInteger(Number(main)) || Number(main) <= 0) throw new Error('Invalid main variant');
    const quantities = new Map();
    [main, second].filter(Boolean).forEach(id => {
      if (!Number.isSafeInteger(Number(id)) || Number(id) <= 0) throw new Error('Invalid variant');
      quantities.set(Number(id), (quantities.get(Number(id)) || 0) + 1);
    });
    return Array.from(quantities, ([id, quantity]) => ({id, quantity}));
  }
  class ClassicMaskOffers extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const dictionary = document.querySelector('script[data-classic-labels]');
      if (!dictionary) return;
      this.labels = JSON.parse(dictionary.textContent);
      this.data = JSON.parse(this.querySelector('[data-offer-data]').textContent);
      this.querySelectorAll('[data-label]').forEach(el => { el.textContent = this.labels[el.dataset.label] || ''; });
      this.querySelectorAll('[data-label-aria]').forEach(el => { el.setAttribute('aria-label',this.labels[el.dataset.labelAria] || ''); });
      this.format = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency',currency:this.dataset.currency});
      this.secondaryBlocks=[];
      this.upsellPanel=this.querySelector('[data-upsell]');
      this.upsellVariants=JSON.parse(this.querySelector('[data-upsell-variants]')?.textContent || '[]');
      this.upsellToggle=this.querySelector('[data-upsell-toggle]');
      if(this.upsellPanel&&!this.upsellVariants.length)this.upsellPanel.hidden=true;
      this.secondOptions = this.querySelectorAll('[data-second-color]');
      this.button = this.querySelector('[data-add]');
      this.status = this.querySelector('[data-status]');
      if (!this.secondOptions.length) this.querySelector('input[value="2"]').disabled = true;
      this.addEventListener('change', () => this.render());
      this.button.addEventListener('click', () => this.add());
      this.render();
      this.ready = true;
      this.hidden = false;
      const productInfo=this.closest('.m-product-info--wrapper');
      if(productInfo){productInfo.classList.add('sh-mask-skinny-style');for(const block of productInfo.querySelectorAll('.main-product__block-price,.main-product__block-variant_picker,.main-product__block-complementary')){if(!block.hidden){this.secondaryBlocks.push({block,display:block.style.display});block.hidden=true;block.style.display='none';}}}
      // Only the adjacent native purchase block for this exact product is replaced.
      // It remains the no-JavaScript fallback; accelerated checkout must not bypass the chosen duo.
      const native = this.closest('.main-product__block')?.nextElementSibling;
      if (native?.classList.contains('main-product__block-buy_buttons')) {
        this.nativeBlock = native;
        native.hidden = true;
        native.style.display = 'none';
      }
      // The theme also renders an independent mobile sticky purchase form.
      // Hide it only while this opt-in offer is active, so it cannot bypass the selected duo.
      this.stickyBlock = document.querySelector('.m-sticky-addtocart');
      if (this.stickyBlock) {
        this.stickyBlock.hidden = true;
        this.stickyBlock.style.display = 'none';
      }
    }
    disconnectedCallback() {
      this.closest('.m-product-info--wrapper')?.classList.remove('sh-mask-skinny-style');
      this.secondaryBlocks?.forEach(({block,display})=>{block.hidden=false;block.style.display=display;});
      if (this.nativeBlock) { this.nativeBlock.hidden = false; this.nativeBlock.style.removeProperty('display'); }
      if (this.stickyBlock) { this.stickyBlock.hidden = false; this.stickyBlock.style.removeProperty('display'); }
    }
    getUpsellVariant() {
      if(!this.upsellPanel)return null;
      const size=this.querySelector('[data-upsell-size]:checked')?.value,color=this.querySelector('[data-upsell-color]:checked')?.value;
      return this.upsellVariants.find(v=>v.size===size&&v.color===color)||null;
    }
    renderUpsell() {
      if(!this.upsellPanel||!this.upsellVariants.length)return;
      const size=this.querySelector('[data-upsell-size]:checked')?.value,colors=Array.from(this.querySelectorAll('[data-upsell-color]'));
      colors.forEach(input=>{input.disabled=!this.upsellVariants.some(v=>v.size===size&&v.color===input.value);input.closest('label').classList.toggle('is-unavailable',input.disabled);});
      if(!colors.some(input=>input.checked&&!input.disabled)){const first=colors.find(input=>!input.disabled);if(first)first.checked=true;}
      this.querySelector('[data-upsell-color-name]').textContent=colors.find(input=>input.checked)?.value||'';
      const selected=this.getUpsellVariant();
      this.querySelector('[data-upsell-options]').hidden=!this.upsellToggle.checked;
      this.upsellPanel.classList.toggle('is-selected',this.upsellToggle.checked);
      if(selected){
        this.querySelector('[data-upsell-price]').textContent='+ '+this.format.format(selected.price/100);
        const compare=this.querySelector('[data-upsell-compare]');compare.hidden=!selected.compare||selected.compare<=selected.price;compare.textContent=this.format.format((selected.compare||selected.price)/100);
        this.querySelector('[data-upsell-image]').src=selected.image;
        const link=this.querySelector('[data-upsell-link]');if(!link.dataset.base)link.dataset.base=link.getAttribute('href');
        link.href=link.dataset.base+'?variant='+selected.id;
      }
    }
    render() {
      this.renderUpsell();
      const duo = this.querySelector('input[value="2"]:checked') !== null;
      const secondPrice = Number(this.querySelector('[data-second-color]:checked')?.dataset.price || 0);
      this.querySelector('[data-second-wrap]').hidden = !duo;
      this.querySelector('[data-duo-price]').textContent = this.format.format((this.data.price + secondPrice)/100);
      const secondCompare=Number(this.querySelector('[data-second-color]:checked')?.dataset.compare||secondPrice);
      const duoCompare=Number(this.data.compare||this.data.price)+secondCompare;
      const compare=this.querySelector('[data-duo-compare]');compare.hidden=duoCompare<=this.data.price+secondPrice;compare.textContent=this.format.format(duoCompare/100);
      const saving=duoCompare-this.data.price-secondPrice;const badge=this.querySelector('[data-duo-save]');badge.hidden=saving<=0;badge.textContent=this.labels.save+' '+this.format.format(saving/100);
      this.querySelector('[data-solo-price]').textContent=this.format.format(this.data.price/100);
      const second=this.querySelector('[data-second-color]:checked');
      if(second?.dataset.image)this.querySelector('[data-second-preview]').src=second.dataset.image;
      this.querySelectorAll('.sh-classic-offers__card').forEach(card=>card.classList.toggle('is-selected',card.querySelector('input').checked));
    }
    async add() {
      if (this.busy) return;
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy','true');
      this.status.textContent = '';
      const root = this.dataset.root.replace(/\/?$/, '/');
      const duo = this.querySelector('input[value="2"]:checked') !== null;
      let added = false;
      try {
        const second = duo ? this.querySelector('[data-second-color]:checked')?.value : null;
        if (duo && !second) throw new Error('Choose a second mask');
        const items = makeItems(this.data.id, second);
        if(this.upsellToggle?.checked){
          const pillow=this.getUpsellVariant();if(!pillow)throw new Error('Choose an available pillowcase');
          items.push({id:Number(pillow.id),quantity:1});
        }
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items,sections:['cart-drawer'],sections_url:location.pathname}),credentials:'same-origin'});
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || this.labels.error);
        added = true;
        this.status.textContent = this.labels.added;
        const drawer = document.querySelector('m-cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && payload.sections?.['cart-drawer'] && window.MinimogSettings?.enable_cart_drawer !== false) {
          drawer.renderContents(payload);
          if (typeof drawer.getCart === 'function' && typeof drawer.updateCartCount === 'function') {
            drawer.getCart().then(cart => drawer.updateCartCount(cart.item_count)).catch(() => {});
          }
        } else { location.assign(this.dataset.cart); }
      } catch (error) {
        if (added) { location.assign(this.dataset.cart); return; }
        // A network failure may occur after Shopify accepted a request. Never auto-retry.
        this.status.textContent = this.labels.error;
        const link = document.createElement('a');
        link.href = this.dataset.cart;
        link.textContent = ' ' + this.labels.cart;
        this.status.append(link);
      } finally {
        this.busy = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('sh-classic-mask-offers', ClassicMaskOffers);
  if (typeof module !== 'undefined') module.exports = {makeItems};
})();
